<template>
  <div class="entrega" id="style-1" >
    <div class="contenedorEntrega">
        <h4><i class="icon-pdr3"></i> Forma de entrega</h4>
        <div class="forma">
          <PuntoRetiro :datos="datos" />
        </div>
   
    <div class="titulo-tl" v-html="getEstadoPedido(datos).titulo"></div>
<!-- {{getEstadoPedido(datos)}} -->
    <SeguimientoLinea :datos="datos" v-if=" datos.sc_ultimo_estado != 32" />
    <div v-if="!datos.envio || datos.sc_ultimo_estado == 32" class="entrega-tab-1">
      <strong style="color:#BFBE51">IMPORTANTE:</strong>
      El punto de retiro seleccionado no puede ser modificado y tenés 30
      días corridos a partir de la llegada del pedido para retirarlo,
      luego de ese tiempo procederemos a realizar la devolución de la
      compra.
    </div>
    </div>
  </div>
</template>

<script>
import estadosMixins from "@/mixins/estadosMixins.js";
export default {
  props: ["datos"],
  mixins: [estadosMixins],
  components: {
    SeguimientoLinea: () => import("@/components/seguimientoLinea"),
    PuntoRetiro: () => import("@/components/puntoRetiro.vue"),
  },
  computed: {


   


  },
}
</script>

<style lang="scss" scoped>
.titulo-tl{
  display: block;
  text-align: left;
  margin-top: 20px;
  font-weight: bold;
}
.titulo-tl strong{
  display: block;
  text-align: left;
  color: #d2d2d2
}
.titulo-tl span{
  display: block;
  text-align: left;
  color: #d2d2d2;
  font-weight: normal;
}
.forma{
  background: #f7f6cf;
  padding: 20px;
  line-height: 1.4;
}
.entrega{
  padding:20px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 520px;

}
.contenedorEntrega{
 overflow: visible;
  
}
.entrega h4 {
  text-align: left;
  margin:0;
  margin-bottom: 10px;
}
.entrega-tab-1 {

  border-top: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 13.5px;
  text-align: left;
  //   padding-left: 40px;
  // width: 100%;
  // padding-bottom: 0;
}
@media screen and (max-width: 768px) {
.entrega{
  padding:10px;
  // margin-bottom: 150px;
  height: 100vh;
}
.contenedorEntrega{
 overflow: visible;
   margin-bottom: 150px;

  
}
  
}
</style>